<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col>
      </b-col>
      <b-col class="text-center title">系統管理 / App版本管理</b-col>
      <b-col>
      </b-col>
    </b-row>
    <b-card class="mb-2">
    <div style="padding: 0.75rem">
      <form>
      <fieldset>
      <legend>Android</legend>
        <div class="text-right">
          <button type='button' class='btn btn-warning text-white' v-show='FunctionPermission > 1 && btn_edit_a' @click='btn_edit_a = !btn_edit_a'>修改</button>
          <button type="button" class="btn btn-save" v-if='FunctionPermission > 1 && !btn_edit_a' @click="save('android')">儲存</button>
          <button type="button" class="btn btn-clear" v-if='FunctionPermission > 1 && !btn_edit_a' @click="cancel('android')">取消</button>
        </div>
                <label for="exampleInput1">重大版本號</label>
                <input id="exampleInput1" type="text" required autofocus placeholder="請輸入" class="form-control" :disabled="btn_edit_a"
                        v-model="isForced_a"/>
                <div class="text-danger" v-if="valid_isForced_a">{{valid_isForced_a}}</div><br />
                <label for="exampleInput2">最新版本號</label>
                <input id="exampleInput2" type="text" required placeholder="請輸入" class="form-control" :disabled="btn_edit_a"
                        v-model="isNew_a"/>
                <div class="text-danger" v-if="valid_isNew_a">{{valid_isNew_a}}</div>
      </fieldset>
      <fieldset>
      <legend>IOS</legend>
        <div class="text-right">
          <button type='button' class='btn btn-warning text-white' v-show='FunctionPermission > 1 && btn_edit_i' @click='btn_edit_i = !btn_edit_i'>修改</button>
          <button type="button" class="btn btn-save" v-if='FunctionPermission > 1 && !btn_edit_i' @click="save('ios')">儲存</button>
          <button type="button" class="btn btn-clear" v-if='FunctionPermission > 1 && !btn_edit_i' @click="cancel('ios')">取消</button>
        </div>
                <label for="exampleInput3">重大版本號</label>
                <input id="exampleInput3" type="text" required autofocus placeholder="請輸入" class="form-control" :disabled="btn_edit_i"
                        v-model="isForced_i"/>
                <div class="text-danger" v-if="valid_isForced_i">{{valid_isForced_i}}</div><br />
                <label for="exampleInput4">最新版本號</label>
                <input id="exampleInput4" type="text" required placeholder="請輸入" class="form-control" :disabled="btn_edit_i"
                        v-model="isNew_i"/>
                <div class="text-danger" v-if="valid_isNew_i">{{valid_isNew_i}}</div>
      </fieldset>
      </form>
    </div>
    </b-card>
        <!-- Double Check Modal -->
        <b-modal ref="mdCheck" hide-footer title="版號變更">
          <b-container fluid>
            <form>
              <div class="row mb-3">
                <label class="control-label">確定修改{{type}}版號 ?</label>
              </div>
              <div class="float-right">
                <b-btn variant="primary" @click="edit(type)">確定</b-btn>
                <b-btn variant="secondary" @click="close">取消</b-btn>
              </div>
            </form>
          </b-container>
        </b-modal>
  </div>
</template>

<script>
// for API_URL
import axios from 'axios'
import {API_URL} from '../../store/root.js'
// for 訊息視窗
import miniToastr from 'mini-toastr'
// 功能權限function
import {getFunctionPermission} from '../../js/LoginUserFunction.js'

export default {
  // name: 'HelloWorld',
  data () {
    return {
      btn_edit_a: true,
      btn_edit_i: true,
      isForced_a: '',
      isNew_a: '',
      isForced_i: '',
      isNew_i: '',
      FunctionPermission: 0, // 功能權限
      queryData_a: undefined,
      queryData_i: undefined,
      valid_errMsg: false,
      valid_isForced_a: '',
      valid_isNew_a: '',
      valid_isForced_i: '',
      valid_isNew_i: '',
      type: ''
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F29') // 功能權限 帶入功能代碼
    if (this.FunctionPermission > 0) {
      this.load('android')
      this.load('ios')
    } else {
      this.$router.push({ name: 'name' })
    }
  },
  methods: {
    load (type) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/version/query', {
        Type: type
      })
        .then((response) => {
          if (response.data.result === '0000') {
            if (type === 'android') {
              this.isForced_a = response.data.data.isForced
              this.isNew_a = response.data.data.isNew
              this.queryData_a = response.data.data
            }
            if (type === 'ios') {
              this.isForced_i = response.data.data.isForced
              this.isNew_i = response.data.data.isNew
              this.queryData_i = response.data.data
            }
            this.$parent.Loading = false
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
              this.$parent.Loading = false
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    cancel (type) {
      if (type === 'android') {
        this.btn_edit_a = !this.btn_edit_a
        if (this.queryData_a !== undefined) {
          this.isForced_a = this.queryData_a.isForced
          this.isNew_a = this.queryData_a.isNew
        }
        this.valid_isForced_a = ''
        this.valid_isNew_a = ''
      }
      if (type === 'ios') {
        this.btn_edit_i = !this.btn_edit_i
        if (this.queryData_i !== undefined) {
          this.isForced_i = this.queryData_i.isForced
          this.isNew_i = this.queryData_i.isNew
        }
        this.valid_isForced_i = ''
        this.valid_isNew_i = ''
      }
    },
    edit (type) {
      this.$refs.mdCheck.hide()
      this.$parent.Loading = true

      var Forced
      var New
      if (type === 'android') {
        Forced = this.isForced_a
        New = this.isNew_a
      }
      if (type === 'ios') {
        Forced = this.isForced_i
        New = this.isNew_i
      }

      return axios.post(API_URL + '/web/version/update', {
        type: type,
        isForced: Forced,
        isNew: New
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            if (type === 'android') {
              this.queryData_a = {
                isForced: this.isForced_a,
                isNew: this.isNew_a
              }
              this.btn_edit_a = !this.btn_edit_a
            }
            if (type === 'ios') {
              this.queryData_i = {
                isForced: this.isForced_i,
                isNew: this.isNew_i
              }
              this.btn_edit_i = !this.btn_edit_i
            }
            this.$parent.Loading = false
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
              this.$parent.Loading = false
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    checkVersionForInt (value) {
      var ary = value.split('.')
      var i
      var re = /^\d+$/
      for (i = 0; i < ary.length; i++) {
        if (!re.test(ary[i])) {
          return false
        }
      }
      return true
    },
    save (type) {
      this.type = type
      this.valid_errMsg = false
      if (type === 'android') {
        if (!this.isForced_a) {
          this.valid_errMsg = true
          this.valid_isForced_a = '版本號為必填'
        } else {
          if (/[^0-9.]$|(\.{2,})|^[^0-9]|[^0-9]$/.test(this.isForced_a)) {
            this.valid_errMsg = true
            this.valid_isForced_a = '格式有誤'
          } else {
            if (!this.checkVersionForInt(this.isForced_a)) {
              this.valid_errMsg = true
              this.valid_isForced_a = '格式有誤'
            } else {
              this.valid_isForced_a = ''
            }
          }
        }
        if (!this.isNew_a) {
          this.valid_errMsg = true
          this.valid_isNew_a = '版本號為必填'
        } else {
          if (/[^0-9.]$|(\.{2,})|^[^0-9]|[^0-9]$/.test(this.isNew_a)) {
            this.valid_errMsg = true
            this.valid_isNew_a = '格式有誤'
          } else {
            if (!this.checkVersionForInt(this.isNew_a)) {
              this.valid_errMsg = true
              this.valid_isNew_a = '格式有誤'
            } else {
              this.valid_isNew_a = ''
            }
          }
        }
      }
      if (type === 'ios') {
        if (!this.isForced_i) {
          this.valid_errMsg = true
          this.valid_isForced_i = '版本號為必填'
        } else {
          if (/[^0-9.]$|(\.{2,})|^[^0-9]|[^0-9]$/.test(this.isForced_i)) {
            this.valid_errMsg = true
            this.valid_isForced_i = '格式有誤'
          } else {
            if (!this.checkVersionForInt(this.isForced_i)) {
              this.valid_errMsg = true
              this.valid_isForced_i = '格式有誤'
            } else {
              this.valid_isForced_i = ''
            }
          }
        }
        if (!this.isNew_i) {
          this.valid_errMsg = true
          this.valid_isNew_i = '版本號為必填'
        } else {
          if (/[^0-9.]$|(\.{2,})|^[^0-9]|[^0-9]$/.test(this.isNew_i)) {
            this.valid_errMsg = true
            this.valid_isNew_i = '格式有誤'
          } else {
            if (!this.checkVersionForInt(this.isNew_i)) {
              this.valid_errMsg = true
              this.valid_isNew_i = '格式有誤'
            } else {
              this.valid_isNew_i = ''
            }
          }
        }
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      this.$refs.mdCheck.show()
    },
    close () {
      this.$refs.mdCheck.hide()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.ui-breadcrumb {
  margin-bottom: 0;
}
fieldset {
  padding: 8px 22px 18px;
  margin: 0 0 18px;
  border: 1px solid #519b39;
}
legend {
  padding: 0.2em;
  border: 0;
  width: auto;
  color: #519b39;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/Version.vue